import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";

// Assets
const HEADER_BG = "https://static.wixstatic.com/media/e92216_71146555c7c242f6998c3f83cfd1c9c7~mv2.jpg/v1/fill/w_1904,h_487,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/e92216_71146555c7c242f6998c3f83cfd1c9c7~mv2.jpg";
const CHIEF_IMG = "https://static.wixstatic.com/media/e92216_9e91be7f51c848e48cd422c91cb558b6~mv2.jpg/v1/crop/x_468,y_0,w_602,h_720/fill/w_422,h_506,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/e92216_9e91be7f51c848e48cd422c91cb558b6~mv2.jpg";
const HISTORY_IMG_1 = "https://static.wixstatic.com/media/e92216_c6cd93a903d6493ca3037e2eedb50cde~mv2.jpg/v1/fill/w_1904,h_1231,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/e92216_c6cd93a903d6493ca3037e2eedb50cde~mv2.jpg";

const About = () => {
  return (
    <div className="flex flex-col min-h-screen bg-white">
      {/* 1. Hero Section */}
      <div className="relative h-[50vh] bg-black flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${HEADER_BG})` }} />
        <div className="absolute inset-0 bg-black/40" />
        <div className="relative container mx-auto px-4 text-center z-10">
          <h2 className="text-[#D97706] font-heading font-bold tracking-widest uppercase mb-4 text-xl">ᐧᐋᒋᔦ - WÂCIYÊ</h2>
          <h1 className="text-5xl md:text-7xl font-heading font-bold text-white uppercase mb-6">About Frog Lake</h1>
          <p className="text-xl text-gray-200 max-w-2xl mx-auto">
            Rich in history, lakes and nature. From exciting new business opportunities to breathtaking scenery, Frog Lake has it.
          </p>
        </div>
      </div>

      {/* 2. Chief's Letter */}
      <section className="py-20 bg-zinc-50">
        <div className="container mx-auto px-4 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h4 className="text-[#D97706] font-heading font-bold uppercase tracking-widest mb-4">ᐙᒋᔮ ᑕᓂᓯ</h4>
            <h2 className="text-4xl font-heading font-bold mb-6 text-black uppercase">A Letter From Our Chief</h2>
            <div className="space-y-6 text-gray-600 leading-relaxed">
              <p>
                On behalf of myself and the Council, I would like to thank you for choosing our community to be your home. Residents here enjoy a fully balanced lifestyle – a great community atmosphere, an easily accessible location, an exceptional school system, and a thriving business community.
              </p>
              <p>
                Living in Frog Lake also means you have access to some of the highest quality services in the area; Police and Fire service, Water, Health, Streets, Parks and Recreation, Forestry, and our Library are all available for you when you need their services.
              </p>
              <p>
                We hope this website answers some of the questions you have about Frog Lake services and programs. Don’t hesitate to stop in to see us in person at the Administrative building if you need additional information.
              </p>
            </div>
          </div>
          <div className="relative">
             <img src={CHIEF_IMG} alt="Chief" className="w-full h-auto object-cover rounded shadow-lg border-b-8 border-[#D97706]" />
          </div>
        </div>
      </section>

      {/* 3. History Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-heading font-bold uppercase mb-4">Frog Lake History</h2>
            <div className="h-1 w-20 bg-[#D97706] mx-auto" />
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-12">
            <div>
              <h3 className="text-2xl font-bold uppercase mb-4 text-zinc-800">Rising Tensions</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                Although it was not a military engagement, the incident known as the Frog Lake Massacre proved to be one of the most influential events associated with the North West Resistance.
                The Frog Lake Massacre was part of the Cree uprising during the North-West Rebellion in western Canada.
              </p>
              <p className="text-gray-600 mb-6 leading-relaxed">
                The events at Frog Lake occurred during a time of heightened tension between Prairie First Nations and the Government of Canada. The Plains Cree were faced with severe food shortages due to the sharp decline in bison herds and the government’s decision to withhold rations that had been promised in Treaty 6.
              </p>
            </div>
            <div className="h-80 bg-gray-100 rounded overflow-hidden">
               <img src={HISTORY_IMG_1} alt="History" className="w-full h-full object-cover" />
            </div>
          </div>

          <div className="bg-zinc-50 p-8 rounded border-l-4 border-[#D97706]">
            <h3 className="font-bold text-lg mb-2">Historical Context</h3>
            <p className="text-gray-600 italic">
              "More recent research and insights from oral histories have shown that Canada’s First Nations policies contributed to the tragedy at Frog Lake, further illuminating the complexity of the Plains Cree peoples’ situation and their efforts to maintain peace."
            </p>
          </div>
        </div>
      </section>

      {/* 4. Leadership History (Table style) */}
      <section className="py-20 bg-zinc-900 text-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-heading font-bold uppercase mb-12 text-center">History of Leadership</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center md:text-left">
            <div>
              <h4 className="text-[#D97706] font-bold text-xl mb-4">1878–1888</h4>
              <ul className="space-y-2 text-gray-400">
                <li>Chief Puskeeahkayweein</li>
                <li>Cllr. Moostahtuck</li>
                <li>Cllr. Oowwusk</li>
              </ul>
            </div>
            <div>
              <h4 className="text-[#D97706] font-bold text-xl mb-4">1918-1927</h4>
              <ul className="space-y-2 text-gray-400">
                <li>Chief Napayo</li>
                <li>Cllr. Musinkusquapew</li>
              </ul>
            </div>
            <div>
              <h4 className="text-[#D97706] font-bold text-xl mb-4">Recent Era</h4>
              <ul className="space-y-2 text-gray-400">
                <li>Chief George Stanley (2005-2007)</li>
                <li>Chief Roland Quinney (2003-2005)</li>
                <li>Chief Raymond Quinney (1999-2001)</li>
              </ul>
            </div>
          </div>
          
          <div className="mt-12 text-center text-xs text-gray-500">
            * Complete list available in archives. Some Cree names may be historically spelled differently.
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
